import {useCallback, useMemo, useState} from "react";
import {getApiUrl} from "../../utils/urls";
import axios from "axios";
import cookiesProvider from "../cookies-provider";

export function useDataProvider() {
  const [loading, setLoading] = useState(false);
  const http = useMemo(() => axios.create({ baseURL: getApiUrl() }), [])
  const request = useCallback(({
    method, body, headers, query, path, responseType
  }) => {
    const token = cookiesProvider.getToken();
    setLoading(true);
    if (!headers) {
      headers = {
        'Authorization': `Bearer ${token}`
      }
      if (!(body instanceof FormData)) {
        headers["Content-Type"] = "application/json";
      }
    }

    return http.request({
      method,
      url: path,
      params: query,
      data: body,
      headers,
      responseType
    }).finally(() => setLoading(false));
  }, [http])


  return {
    request,
    loading
  }

}